import ajax from '../http/ajax'

export const getGraphValidateCode = (data) => {
    return ajax.get('getGraphValidateCode')
}
